var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 15,
    viewBox: "0 0 20 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.24863 0.00195312H18.7297C19.4193 0.00195312 19.9784 0.560672 19.9783 1.24973V13.7277C19.9783 14.4167 19.4193 14.9755 18.7297 14.9755H1.24863C0.5591 14.9755 0 14.4168 0 13.7277V1.24973C0 0.560672 0.5591 0.00195312 1.24863 0.00195312ZM17.4811 2.49755H2.4973V12.4799H6.24323L12.4865 6.24093L17.4811 11.2321V2.49755Z",
    fill: "#BDBDBD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.19152 4.29431C8.92298 5.02526 8.92298 6.21034 8.19152 6.9413C7.46007 7.67225 6.27418 7.67225 5.54273 6.9413C4.81128 6.21034 4.81128 5.02526 5.54273 4.29431C6.27418 3.56336 7.46007 3.56336 8.19152 4.29431Z",
    fill: "#BDBDBD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.177b51217d750db330b02ffd59fcb493.svg";
export { ForwardRef as ReactComponent };